import React, { useEffect } from 'react';
import css from './BMap.less';

const BMaps = props => {
  const init = () => {
    const { address } = props;
    // console.log(address);
    const { BMap } = window;
    const map = new BMap.Map('address');
    const point = new BMap.Point(
      address.longitude || 116.404,
      address.latitude || 39.915,
    ); // 创建点坐标
    // 初始化地图，设置中心点坐标和地图级别
    map.centerAndZoom(point, 15);
    const opt = { type: 'BMAP_NAVIGATION_CONTROL_SMALL' };
    map.addControl(new BMap.NavigationControl(opt));
    // 创建标注
    const marker = new BMap.Marker(point);
    // 将标注添加到地图中
    map.addOverlay(marker);
    const opts = {
      width: 250, // 信息窗口宽度
      height: 100, // 信息窗口高度
      title: '', // 信息窗口标题
    };
    // 创建信息窗口对象
    opts.title = address.short_name || '';
    const msg = address.address || '';
    const infoWindow = new BMap.InfoWindow(msg, opts);
    // 打开信息窗口
    map.openInfoWindow(infoWindow, map.getCenter());
  };

  useEffect(() => {
    init();
  }, []);

  const { address } = props;
  return (
    <React.Fragment key={address.id.toString()}>
      <div className={css.address} id="address">
        {' '}
      </div>
    </React.Fragment>
  );
};

export default BMaps;
